import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import 'rxjs/add/operator/map';

@Injectable()
export class OrganizationService {
  constructor (private http: Http) {}

  getOrganizations() {
    let body = {};
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('bearer')}` });
    let options = new RequestOptions({ headers });
    
    return this.http.post('https://apidev.hvsfinancial.com/api/CoreOrganization/GetOrganizations', body, options)
      .map((response: Response) => {
        return response;
      });
  }
}
